import { createContext } from 'react'

const RepositoryContext = createContext([{ name: '', enabled: false, strategies: [{ name: '', parameters: {} }] }])

export default RepositoryContext
